import styled from '@emotion/styled'
import { AdmRuleHistory, RuleItem } from '@pubstack/common/src/adm/rules'
import { FunctionComponent, useState } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Flyout } from '~/components/Flyout'
import { BaseInputElement } from '~/components/Input'
import { WithClassName } from '~/types/utils'
import { Checkbox } from '@pubstack/ui/components/Checkbox'
import { Icon } from './Icon'
import { RuleHistory } from './RuleHistory'
import { Skeleton } from './Skeleton'

const Bloc = styled.div`
  padding: 8px 12px 20px 12px;
  margin-bottom:20px;
  border: 1px solid ${Colors.Platinum};
  border-radius: 4px;
  h1 {
    ${Fonts.P1}
    font-weight: 700;
    line-height: 30px;
    border-bottom: 1px solid ${Colors.Platinum};
    margin-bottom:10px;
  }
`
const SearchBar = styled.form`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 14px;
  & input[type='text'] {
    width: 370px;
  }
`
const Loading = styled.div`
  h1 {
    padding-bottom: 4px;
  }
  & div {
    padding-left: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`
type HistoryFlyoutProps = WithClassName & {
  item: RuleItem
  data: AdmRuleHistory
  isLoading?: boolean
}

export const HistoryFlyout: FunctionComponent<HistoryFlyoutProps> = ({ item, data, isLoading }) => {
  const [lastUpdates, setLastUpdates] = useState(false)
  const [search, setSearchValue] = useState('')
  const filteredData = Object.values(data).map((d) => d.filter((a) => !search || a.name.toLowerCase().includes(search.toLowerCase())))

  return (
    <Flyout.Content>
      <Flyout.Title>{item} history</Flyout.Title>
      <Flyout.Body>
        <SearchBar>
          <BaseInputElement name={'search'} type={'text'} iconLeft={'search'} labelIsPlaceholder label={'Search'} onChange={(event) => setSearchValue(event.target.value)} />
          <Checkbox name={'lastUpdates'} className={'shrink-0'} label={'Show only last updates'} checked={lastUpdates} onChange={setLastUpdates} trackingLabel={'adm-history-last-updates-view'} />
        </SearchBar>
        {filteredData.map((itemHistory, index) => {
          return (
            itemHistory.length > 0 && (
              <Bloc key={index}>
                {isLoading ? (
                  <Loading>
                    <h1>
                      <Skeleton width={'160px'} bigger />
                    </h1>
                    <div>
                      <Icon name={'circle'} width="8px" fill={Colors.Platinum} />
                      <Skeleton width={'720px'} bigger />
                    </div>
                  </Loading>
                ) : (
                  <>
                    <h1>{itemHistory[0].name}</h1>
                    <RuleHistory ruleHistory={lastUpdates ? [itemHistory[0]] : itemHistory} item={item} />
                  </>
                )}
              </Bloc>
            )
          )
        })}
      </Flyout.Body>
    </Flyout.Content>
  )
}
